export default __webpack_public_path__ + "static/media/inter.4e316b65.jpg";